export default __webpack_public_path__ + "static/media/image4.9ecd4b8b.jpg";